import axios from "axios";
function jsonp(url) {
  return new Promise((resolve, reject) => {
    // 这里的 "jsonCallBack" ，和调用的 jsonp 的 url 中的 callback 值相对应（见粗体字）

    window.jsonCallBack = (result) => {
      resolve(result);
    };

    const JSONP = document.createElement("script");

    JSONP.type = "text/javascript";

    JSONP.src = url;

    document.getElementsByTagName("head")[0].appendChild(JSONP);

    setTimeout(() => {
      document.getElementsByTagName("head")[0].removeChild(JSONP);
    }, 500);
  });
}
// 获取省市区 //apis.map.qq.com/ws/geocoder/v1/?location=
export function getPosition(data) {
  const APPKEY = 'IR3BZ-NV6KV-VGDPA-5DPZ2-S32XO-SEFED'
  const { longitude, latitude } = data;
  return jsonp(`//apis.map.qq.com/ws/geocoder/v1?callback=jsonCallBack&output=jsonp&location=${latitude},${longitude}&key=${APPKEY}&get_poi=0`);
  
}
// 获取经纬度 apis.map.qq.com/ws/location/v1/ip
export function getLoction() {
  return new Promise((resolve, reject) => {
    axios({
      method: "get",
      url: `/ws/location/v1/ip?key=6LUBZ-5JQKS-LP2OJ-62AE6-XCNQS-VOBES`,
      baseURL: "//apis.map.qq.com",
    }).then(
      (res) => {
        // state.commit("changeShowOverlay", false);
        if (res && res.status === 200) {
          resolve(res.data);
        } else {
          reject(res.msg);
        }
      },
      (error) => {
        // state.commit("changeShowOverlay", false);
        reject(error);
      }
    );
  });
}
